import { render, staticRenderFns } from "./advertisementTab.vue?vue&type=template&id=16a07be9&lang=pug"
import script from "./advertisementTab.vue?vue&type=script&lang=js"
export * from "./advertisementTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports